import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Grid, Button, Snackbar, Box, Typography } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import ContactDetailField from "../../../molecules/ContactDetailField";
import TextArea from "../../../atoms/Textarea";
import DynamicCheckbox from "../../../molecules/DynamicCheckbox";
import { useLocation } from "react-router-dom";
import PrintComponent from "../../PrintComponent";
import DeliveryRequestDownload from "./download";
import moment from "moment";
import MySignatureCanvas from "../../../molecules/signature_canvas";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DescriptionIcon from "@mui/icons-material/Description";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import CommentIcon from "@mui/icons-material/Comment";

const DeliveryRequestClientSide = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");

  const [isEdit, setIsEdit] = useState(true);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data, mdKeys) => {
    setIsLoading(true);

    let media = [];
    if (formContent?.clientSign != "") media[0] = formContent?.clientSign;

    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: mdKeys ? mdKeys : [],
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        if (data != undefined)
          setSnackbarMessage("Signature has been added successfully!");
        else
          setSnackbarMessage(
            "Delivery Request Form has been updated successfully!"
          );

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);




  //
  //
  const uploadFile = async (file) => {

    const fd = new FormData();
    fd.append("image", file);

    imageUploadClientPreview(fd, surveyId, formId, email, token)
      .then((res) => {
        let values = { ...formContent };
        values.clientSign = res?.data?.data?.key;
        setFormContent(values);

        setTimeout(() => {
          updateContent(values, [res?.data?.data?.key]);
        }, 1500);
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });

  };

  const [isSignCanvas, setSignCanvas] = useState(false);


  const [surveyData, setSurveyData] = useState([]);



  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
            title="Delivery Request Form"
             hideBackButton={true}
            actions={
                <div className="d-flex gap-3">
                    {!isEdit && (
                        <Button
                            variant="contained"
                            onClick={() => {
                                setIsEdit(true);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                            startIcon={<NoteAltIcon />}
                        >
                            Edit
                        </Button>
                    )}

                    {formContent?.clientSign == "" && !isEdit && (
                         <Button
                            variant="contained"
                            onClick={() => setSignCanvas(true)}
                            sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                        >
                            Upload Sign
                        </Button>
                    )}

                    {isEdit && (
                         <Button
                            variant="outlined"
                             color="error"
                            onClick={() => {
                                getContent();
                                setIsEdit(false);
                            }}
                            disabled={isLoading}
                             sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
                        >
                            Cancel
                        </Button>
                    )}

                    {isEdit && (
                         <Button
                            variant="contained"
                            onClick={() => {
                                updateContent();
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 32px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                        >
                            Save
                        </Button>
                    )}

                    {!isEdit && (
                         <Button
                            variant="contained"
                            onClick={() => {
                                if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                                const tempTitle = document.title;
                                const newTitle = `Delivery-Request-${formContent?.clientName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
                                document.title = newTitle;
                                
                                // Standardized delay for print and title restoration
                                setTimeout(() => {
                                    window.print();
                                    setTimeout(() => {
                                        document.title = tempTitle;
                                    }, 2000);
                                }, 500);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--text-main)",
                                boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                                '&:hover': { backgroundColor: '#000' }
                            }}
                            startIcon={<DescriptionIcon />}
                        >
                            Save as PDF
                        </Button>
                    )}
                </div>
            }
        >

             {/* Customer Details */}
            <SectionHeader title="Customer Details" icon={<DescriptionIcon />} />
             <PremiumCard sx={{ marginBottom: "32px" }}>
             <PremiumCard sx={{ marginBottom: "32px" }}>
                 <Grid container spacing={3}>
                     <Grid item xs={12} md={6}>
                          <ContactDetailField
                            label="Customer Name"
                            isEdit={isEdit}
                            type="text"
                            value={formContent?.clientName}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.clientName = e.target.value;
                                setFormContent(values);
                            }}
                        />
                     </Grid>
                     <Grid item xs={12} md={6}>
                          <ContactDetailField
                            label="Date"
                            isEdit={isEdit}
                            type="date"
                            value={formContent?.date}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.date = e.target.value;
                                setFormContent(values);
                            }}
                        />
                     </Grid>
                 </Grid>
             </PremiumCard>
             </PremiumCard>

             {/* Delivery Details */}
            <SectionHeader title="Delivery Details" icon={<LocalShippingIcon />} />
            <PremiumCard sx={{ marginBottom: "32px" }}>
            <PremiumCard sx={{ marginBottom: "32px" }}>
                <Grid container spacing={3} sx={{ mb: 4 }}>
                    <Grid item xs={12}>
                         <label
                           htmlFor="deliveryAddress"
                           className={`fw-bold d-block text-secondary mb-2`}
                         >
                           Delivery Address:
                         </label>
                         {!isEdit ? (
                             <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                {formContent?.deliveryAddress || "-"}
                             </Typography>
                         ) : (
                         <TextArea
                            rows="3"
                            style="full-border-field"
                            id="deliveryAddress"
                            value={formContent?.deliveryAddress}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.deliveryAddress = e.target.value;
                                setFormContent(values);
                            }}
                         />
                         )}
                    </Grid>
                </Grid>
                <Box sx={{ mt: 4, mb: 2 }}>
                    <Typography variant="body1" sx={{ fontWeight: 700, color: 'var(--primary-color)' }}>
                        On which date and time you want to receive your goods?
                    </Typography>
                </Box>
                 <Grid container spacing={3}>
                     <Grid item xs={12} md={6}>
                         <ContactDetailField
                            label="Date"
                            isEdit={isEdit}
                            type="date"
                            value={formContent?.deliveryDate}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.deliveryDate = e.target.value;
                                setFormContent(values);
                            }}
                         />
                     </Grid>
                     <Grid item xs={12} md={6}>
                          <ContactDetailField
                            label="Time"
                            isEdit={isEdit}
                            type="time"
                            value={formContent?.deliveryTime}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.deliveryTime = e.target.value;
                                setFormContent(values);
                            }}
                          />
                     </Grid>
                 </Grid>
            </PremiumCard>
            </PremiumCard>

             {/* Permissions & Requirements */}
             <SectionHeader title="Permissions & Requirements" icon={<DescriptionIcon />} />
             <PremiumCard sx={{ marginBottom: "32px" }}>
             <PremiumCard sx={{ marginBottom: "32px" }}>
                 <Grid container spacing={3} sx={{ mb: 3 }}>
                     <Grid item xs={12}>
                         <DynamicCheckbox
                            label="Is there any vehicle/crew permission/security access/permit required of our team/vehicle at your residence?"
                            checkId1="check1"
                            checkLabel1="Yes"
                            checkId2="check2"
                            checkLabel2="No"
                            value1={formContent?.permissions}
                            value2={formContent?.permissions}
                            onChange1={(e) => {
                                let values = { ...formContent };
                                values.permissions = true;
                                setFormContent(values);
                            }}
                            onChange2={(e) => {
                                let values = { ...formContent };
                                values.permissions = false;
                                setFormContent(values);
                            }}
                            disabled={!isEdit}
                        />
                     </Grid>
                 </Grid>
                 {formContent?.permissions && (
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                             <label
                                htmlFor="advise"
                                className={`fw-bold d-block text-secondary mb-2`}
                            >
                                If yes, please advise requirement:
                            </label>
                             {!isEdit ? (
                                  <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                    {formContent?.adviseRequirement || "-"}
                                  </Typography>
                            ) : (
                                <TextArea
                                rows="3"
                                style="full-border-field"
                                id="advise"
                                value={formContent?.adviseRequirement}
                                onChange={(e) => {
                                    let values = { ...formContent };
                                    values.adviseRequirement = e.target.value;
                                    setFormContent(values);
                                }}
                                />
                            )}
                        </Grid>
                    </Grid>
                 )}
             </PremiumCard>
             </PremiumCard>
            
            {/* Priorities */}
             <SectionHeader title="Packing Request Priorities" icon={<LocalShippingIcon />} />
             <PremiumCard sx={{ marginBottom: "32px" }}>
             <PremiumCard sx={{ marginBottom: "32px" }}>
                 <Grid container spacing={3} sx={{ mb: 4 }}>
                     <Grid item xs={12}>
                        <label className={`fw-bold d-block text-secondary mb-2`}>
                            1st priority items to receive according to the packing list:
                        </label>
                         {!isEdit ? (
                             <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                {formContent?.firstPriority || "-"}
                             </Typography>
                        ) : (
                        <TextArea
                            rows="2"
                            style="full-border-field"
                            id="firstPriority"
                            value={formContent?.firstPriority}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.firstPriority = e.target.value;
                                setFormContent(values);
                            }}
                        />
                        )}
                     </Grid>
                 </Grid>
                 <Grid container spacing={3} sx={{ mb: 4 }}>
                     <Grid item xs={12}>
                        <label className={`fw-bold d-block text-secondary mb-2`}>
                            2nd priority items to receive according to the packing list:
                        </label>
                         {!isEdit ? (
                             <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                {formContent?.secondPriority || "-"}
                             </Typography>
                        ) : (
                        <TextArea
                            rows="2"
                            style="full-border-field"
                            id="secondPriority"
                            value={formContent?.secondPriority}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.secondPriority = e.target.value;
                                setFormContent(values);
                            }}
                        />
                        )}
                     </Grid>
                 </Grid>
                  <Grid container spacing={3}>
                     <Grid item xs={12}>
                        <label className={`fw-bold d-block text-secondary mb-2`}>
                            3rd priority items to receive according to the packing list:
                        </label>
                         {!isEdit ? (
                             <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                {formContent?.thirdPriority || "-"}
                             </Typography>
                        ) : (
                        <TextArea
                            rows="2"
                            style="full-border-field"
                            id="thirdPriority"
                            value={formContent?.thirdPriority}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.thirdPriority = e.target.value;
                                setFormContent(values);
                            }}
                        />
                        )}
                     </Grid>
                 </Grid>
             </PremiumCard>
             </PremiumCard>
            
            {/* Additional Info */}
             <SectionHeader title="Additional Information" icon={<CommentIcon />} />
             <PremiumCard sx={{ marginBottom: "32px" }}>
             <PremiumCard sx={{ marginBottom: "32px" }}>
                 <Grid container spacing={3} sx={{ mb: 4 }}>
                     <Grid item xs={12}>
                        <DynamicCheckbox
                            label="Residence’s rooms are marked / labeled with suitable Info/Numbers/Colors to place items in."
                            checkId1="check1"
                            checkLabel1="Yes"
                            checkId2="check2"
                            checkLabel2="No"
                            value1={formContent?.suitableInfo}
                            value2={formContent?.suitableInfo}
                            onChange1={(e) => {
                                let values = { ...formContent };
                                values.suitableInfo = true;
                                setFormContent(values);
                            }}
                            onChange2={(e) => {
                                let values = { ...formContent };
                                values.suitableInfo = false;
                                setFormContent(values);
                            }}
                            disabled={!isEdit}
                        />
                     </Grid>
                 </Grid>
                 <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <label className={`fw-bold d-block text-secondary mb-2`}>
                            Customer Suggestions/Remarks if any:
                        </label>
                         {!isEdit ? (
                             <Typography variant="body1" sx={{ padding: '12px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0', minHeight: '80px' }}>
                                {formContent?.suggestions || "-"}
                             </Typography>
                        ) : (
                        <TextArea
                            rows="3"
                            style="full-border-field"
                            id="suggestion"
                            value={formContent?.suggestions}
                            onChange={(e) => {
                                let values = { ...formContent };
                                values.suggestions = e.target.value;
                                setFormContent(values);
                            }}
                        />
                        )}
                     </Grid>
                 </Grid>
             </PremiumCard>
             </PremiumCard>

             {/* Signatures */}
             <PremiumCard>
             <PremiumCard>
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={6} className="text-center">
                        <div
                            style={{ height: "90px" }}
                            className="d-flex justify-content-center align-items-end"
                        >
                            {formContent.clientSign != "" &&
                            formContent.clientSign != undefined && (
                                <img
                                src={`${Bucket}${formContent.clientSign}`}
                                height={80}
                                width={200}
                                 style={{maxHeight: '80px', maxWidth: '100%', objectFit: 'contain'}}
                                />
                            )}
                        </div>
                        <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                        <p className="my-1">
                            <b>{"Customer/Authorized"}</b>
                        </p>
                    </Grid>
                    <Grid item xs={12} sm={6} className="text-center">
                        <div
                            style={{ height: "90px" }}
                            className="d-flex justify-content-center align-items-end"
                        >
                             {formContent?.adminSign?.trim()?.length > 0 && (
                                <img
                                src={`${Bucket}${formContent.adminSign}`}
                                height={80}
                                width={200}
                                style={{maxHeight: '80px', maxWidth: '100%', objectFit: 'contain'}}
                                />
                             )}
                        </div>
                         <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                        <p className="my-1">
                            <b>{"Shelozon Movers Packers & Logistics Pvt Ltd."}</b>
                        </p>
                    </Grid>
                </Grid>
            </PremiumCard>
            </PremiumCard>

        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <DeliveryRequestDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* /snackbar */}
      {/* Add signature Modal */}
      {isSignCanvas && (
        <MySignatureCanvas
          open={isSignCanvas}
          onClose={() => {
            setSignCanvas(false);
          }}
          onSuccess={(file) => {
            if (!isLoading) uploadFile(file);
          }}
        />
      )}
    </>
  );
};

export default DeliveryRequestClientSide;
